import { api } from "./api";
import { ApiResponse, ApiError } from '@/types/api';

interface UploadMetadata {
  upload_origin: string;
  params: Record<string, string>;
}

interface UploadResponse {
  success: boolean;
  message: string;
  file: {
    filename: string;
    path: string;
    size: number;
  };
  metadata: {
    phaseFormId: string;
    processId: string;
    formFieldId: string;
  };
}


// Função para validar o arquivo antes do upload
const validateFile = (file: File): void => {
  const MAX_FILE_SIZE = 500 * 1024 * 1024; // 500MB como limite padrão
  
  if (!file) {
    throw new Error('Nenhum arquivo fornecido');
  }

  if (file.size > MAX_FILE_SIZE) {
    throw new Error(`O arquivo é muito grande. O tamanho máximo permitido é ${MAX_FILE_SIZE / (1024 * 1024)}MB`);
  }
};

export const uploadFile = async (
  file: File,
  metadata: UploadMetadata,
  uploadEndpoint: string,
  onProgress?: (progress: number) => void
): Promise<{ path: string; progress: number }> => {
  try {
    // Validação do arquivo
    validateFile(file);

    const formData = new FormData();
    formData.append('file', file);
    formData.append('metadata', JSON.stringify(metadata));

    // Faz o upload usando a API com o endpoint específico
    const response = await api.uploadRequest<UploadResponse>(
      uploadEndpoint,
      formData,
      onProgress
    );

    if ('data' in response && response.data?.success && response.data?.file?.path) {
      return {
        path: response.data.file.path,
        progress: 100
      };
    }

    throw new Error('Resposta inválida do servidor');
  } catch (error) {
    console.error('Erro no upload:', error);
    
    // Trata erros específicos
    if (error instanceof Error) {
      throw new Error(`Falha no upload: ${error.message}`);
    }
    
    throw new Error('Falha no upload do arquivo');
  }
}; 